import React, { useState, useCallback } from "react";

import { platforms, capitalizeFirstLetter } from "./utils";
import Icon from "./icons";

export const BundleDownloadButton = ({ release, isStandalone = true }) => (
  <a
    className={isStandalone ? "btn btn-md btn-primary rounded d-inline-flex align-items-center" : "dropdown-item"}
    href={release.bundleFileUrl}
    title={`Download the release bundle file (.odbx)`}
  >
    {Icon.bundle}
    &nbsp; Bundle file (.odbx)
  </a>
);

const DownloadDropdown = ({ release, os }) => {
  const [oses] = useState({
    current: os,
    list: platforms.filter((platform) => platform !== os),
  });

  const PrimaryDownloadButton = useCallback(
    () =>
      !oses.current ? (
        <button type="button" className="btn btn-md btn-primary rounded disabled">
          Unsupported OS
        </button>
      ) : (
        <a
          href={release[`${oses.current}AppUrl`]}
          className="btn btn-md btn-primary rounded d-inline-flex align-items-center"
          title={`Download the setup file for ${capitalizeFirstLetter(oses.current)}`}
        >
          {Icon[oses.current]}
          &nbsp; Download
        </a>
      ),
    [release, oses]
  );

  const SecondaryDownloadLinks = useCallback(() => {
    return (
      <>
        {oses.list.map((name) => (
          <a
            href={release[`${name}AppUrl`]}
            className="dropdown-item"
            title={`Download the setup file for ${capitalizeFirstLetter(name)}`}
            key={name}
          >
            {Icon[name]}
            &nbsp; Setup file for <span className="text-capitalize">{name}</span>
          </a>
        ))}
      </>
    );
  }, [oses, release]);

  return (
    <>
      <div className="btn-group">
        {PrimaryDownloadButton()}
        <button
          type="button"
          className="btn btn-primary dropdown-toggle dropdown-toggle-split"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span className="sr-only">Toggle Dropdown</span>
        </button>
        <div className="dropdown-menu dropdown-menu-right" data-placement="right">
          {SecondaryDownloadLinks()}
          <div className="dropdown-divider"></div>
          <BundleDownloadButton release={release} isStandalone={false} />
        </div>
      </div>

      <small className="text-center text-muted align-self-end">
        {!oses.current ? (
          "Select from the dropdown menu to download the setup file for other OS"
        ) : (
          <>
            Setup file for <span className="text-capitalize">{oses.current}</span>
          </>
        )}
      </small>
    </>
  );
};

export default DownloadDropdown;
